import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export interface WarehouseFormData {
  received_quantity_kg: number;
  compensation_kg: number;
}

interface WarehouseAdjustmentFormProps {
  data: WarehouseFormData;
  onChange: (data: WarehouseFormData) => void;
  netPayable: number;
}

export function WarehouseAdjustmentForm({
  data,
  onChange,
  netPayable,
}: WarehouseAdjustmentFormProps) {
  const handleReceivedChange = (value: string) => {
    const numValue = parseFloat(value) || 0;
    onChange({
      ...data,
      received_quantity_kg: Math.max(0, numValue),
    });
  };

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="received_quantity">Received Quantity (KG)</Label>
        <Input
          id="received_quantity"
          type="number"
          step="0.01"
          min="0"
          value={data.received_quantity_kg || ''}
          onChange={(e) => handleReceivedChange(e.target.value)}
          placeholder="Enter received quantity"
        />
        <p className="text-xs text-muted-foreground">
          The total quantity received at the warehouse
        </p>
      </div>

      <div className="p-4 bg-muted rounded-lg space-y-2">
        <Label className="text-muted-foreground">Quality Compensation (KG)</Label>
        <div className="text-2xl font-semibold">
          {(data.compensation_kg || 0).toFixed(2)} KG
        </div>
        <p className="text-xs text-muted-foreground">
          Adjust compensation from the Quality tab
        </p>
      </div>

      <div className="p-4 bg-muted rounded-lg space-y-2">
        <Label className="text-muted-foreground">Net Payable (Calculated)</Label>
        <div className="text-2xl font-semibold">
          {netPayable.toFixed(2)} KG
        </div>
        <p className="text-xs text-muted-foreground">
          = Received Quantity - Quality Compensation
        </p>
      </div>

      {data.compensation_kg > data.received_quantity_kg && (
        <p className="text-sm text-destructive">
          Compensation cannot exceed received quantity
        </p>
      )}
    </div>
  );
}
